import { render } from "./FarmToFarmTable.vue?vue&type=template&id=9b4b4d1c&ts=true"
import script from "./FarmToFarmTable.vue?vue&type=script&lang=ts"
export * from "./FarmToFarmTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__